import Breadcrumb from '~/components/atoms/Breadcrumb/Breadcrumb'
import PremiumContentBannerReport from '~/components/blocks/PremiumContentBanner/PremiumContentBannerReport'
import type { PageData } from '~/components/report/types'
import { ComponentTheme } from '~/components/themes'

import ReportAboutSection from '../components/ReportAboutSection/ReportAboutSection'
import ReportHeader from '../components/ReportHeader/ReportHeader'
import ReportSummary from '../components/ReportSummary/ReportSummary'

interface ReportGateProps extends PageData {
  isLoggedIn: boolean
}

export default function ReportGate(props: ReportGateProps) {
  const { isLoggedIn, breadcrumb } = props
  return (
    <>
      <Breadcrumb list={breadcrumb} theme={ComponentTheme.primary} />
      <ReportHeader {...props} />
      <ReportSummary {...props} isLoggedIn={isLoggedIn} />
      <ReportAboutSection
        _id={props._id}
        title={props.title}
        subtitle={props.subtitle}
        summary={props.summary}
        leadImage={props.leadImage}
        isPdfType={props.isPdfType}
        slug={props.slug}
        primaryCategory={props.primaryCategory}
        video={props.video}
        introTitle={props.introTitle}
        introContent={props.introContent}
        secondaryIntroContent={props.secondaryIntroContent}
        pdfFile={props.pdfFile}
        isLoggedIn={isLoggedIn}
      />
      {!isLoggedIn && (
        <PremiumContentBannerReport
          image={props.leadImage}
          overrides={props.premiumBanner}
        />
      )}
    </>
  )
}
